export const evalTypeOptions = [
    { value: "ac", label: "AC" },
    { value: "biosecurity", label: "Biosecurity" },
    { value: "es", label: "ES" },
    { value: "wfd", label: "WFD" }
];